import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./LoyaltyCardDetails.css";

function LoyaltyBookletCard() {
  const [showPopup, setShowPopup] = useState(false);

  // Function to open the popup form
  const handleGetCard = () => {
    setShowPopup(true);
  };

  return (
    <div className="loyalty-page">
      <div className="loyalty-img"> 
        <img src="/img/voucher/splash&save.png" alt="Splash & Save Loyalty Card" />
      </div>
      <div className="loyalty-form-box">
        <h2>Splash & Save Loyalty Card</h2>
        
        {/* Card description */}
        <div className="card-description">
          <p>At Green Kleen, we believe in rewarding our loyal customers for keeping their rides sparkling clean! Introducing our Splash & Save Loyalty Card – the simple, stamp-based way to score free washes and make every visit count.</p>
        </div>
        
        {/* Get Your Card button */}
        <div className="card-actions">
          <button className="get-card-btn" onClick={handleGetCard}>
            Claim your card!
          </button>
        </div>
     
        
        {/* How it works */}
        <div className="how-it-works">
          <h3>How It Works:</h3>
          <ol>
            <li><strong>Get Your Card:</strong> Grab a free loyalty card on your next visit from one of our representatives or logon to https://www.greenkleenoman.com/loyalty-program !</li>
            <li><strong>Earn Digital Stamps:</strong> For every paid wash (any service level), scan the QR code at our location or log it in the app to get a digital stamp. Collect 7 stamps...</li>
            <li><strong>Redeem Your Reward:</strong> Your 8th wash is completely FREE! Redeem instantly in-app or show your digital card at the site.</li>
            <li><strong>Repeat & Save:</strong> After redemption, your progress resets automatically, so keep the savings flowing without missing a beat.</li>
          </ol>
        </div>
        
        {/* Benefits */}
        <div className="benefits">
          <h3>Why You'll Love It:</h3>
          <ul>
            <li><strong>Seamless Tracking:</strong> Check your stamp progress anytime in the app – real-time updates and notifications keep you in the loop.</li>
            <li><strong>Unlimited Potential:</strong> No expiration on stamps, and your digital card is always with you on your phone.</li>
            <li><strong>Big Savings:</strong> Depending on your wash package, you could save up to 15% or more per free wash!</li>
            <li><strong>Exclusive Perks:</strong> App users get push notifications for seasonal promotions, bonus stamps, and special offers.</li>
          </ul>
          <p className="closing-message">Join the Splash & Save club today and turn your routine washes into rewarding adventures. Because a clean car shouldn't clean out your wallet! Stop by Green Kleen or ask our team for details. 🚗</p>
        </div>
        
        {/* Back to loyalty program */}
        <div className="back-link">
          <Link to="/loyalty-program">&larr; Back to Loyalty Program</Link>
        </div>
      </div>
      
      {/* Popup Iframe */}
      {showPopup && (
        <div className="popup-overlay" style={{ display: 'flex', flexDirection: 'column' }}>
          <div className="popup-iframe" style={{
            background: 'white',
            padding: '10px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '90%',
            maxWidth: '620px',
            alignItems: 'stretch'
          }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
              <button 
                onClick={() => setShowPopup(false)}
                style={{
                  height: '30px',
                  width: '30px',
                  background: 'none',
                  border: 'none',
                  color: 'rgb(0, 0, 0)',
                  padding: '7px',
                  borderRadius: '1000px',
                  boxShadow: 'black 0px 0px 1px 1px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold'
                }}
              >
                X
              </button>
            </div>
            <iframe 
              src="https://loyal.azeer.app/green.kleen/cards" 
              title="Loyalty Cards"
              style={{ 
                border: 'none', 
                borderRadius: '8px',
                width: '100%',
                maxWidth: '600px',
                height: '400px',
                maxHeight: '70vh'
              }}
            ></iframe>
          </div>
        </div>
      )}
      
      {/* Add styles for the new elements */}
      <style jsx>{`
        .card-description {
          margin: 20px 0;
          text-align: center;
          color: #555;
          line-height: 1.6;
        }
        
        .card-actions {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin: 25px 0;
        }
        
        .get-card-btn {
          padding: 16px 32px;
          border-radius: 50px;
          font-weight: 700;
          font-size: 18px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: linear-gradient(135deg, #2b6e36, #23822e);
          color: white;
          border: none;
          box-shadow: 0 4px 15px rgba(43, 110, 54, 0.3);
          text-transform: uppercase;
          letter-spacing: 1px;
          position: relative;
          overflow: hidden;
        }
        
        .get-card-btn:hover {
          background: linear-gradient(135deg, #23822e, #1e6b28);
          box-shadow: 0 6px 20px rgba(43, 110, 54, 0.4);
          transform: translateY(-2px);
        }
        
        .get-card-btn:active {
          transform: translateY(1px);
          box-shadow: 0 2px 10px rgba(43, 110, 54, 0.3);
        }
        
        .get-card-btn::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 5px;
          height: 5px;
          background: rgba(255, 255, 255, 0.5);
          opacity: 0;
          border-radius: 100%;
          transform: scale(1, 1) translate(-50%);
          transform-origin: 50% 50%;
        }
        
        .get-card-btn:focus:not(:active)::after {
          animation: ripple 1s ease-out;
        }
        
        @keyframes ripple {
          0% {
            transform: scale(0, 0);
            opacity: 0.5;
          }
          100% {
            transform: scale(50, 50);
            opacity: 0;
          }
        }
        
        .how-it-works, .benefits {
          margin: 25px 0;
          text-align: left;
        }
        
        .how-it-works h3, .benefits h3 {
          margin-bottom: 12px;
          color: #2b6e36;
          text-align: center;
        }
        
        .how-it-works ol, .benefits ul {
          padding-left: 20px;
          text-align: left;
          max-width: 500px;
          margin: 0 auto;
        }
        
        .how-it-works li, .benefits li {
          margin-bottom: 15px;
          line-height: 1.5;
          text-align: left;
        }
        
        .closing-message {
          margin-top: 20px;
          font-style: italic;
          text-align: center;
          color: #555;
          line-height: 1.6;
        }
        
        .back-link {
          margin-top: 20px;
          text-align: center;
        }
        
        .back-link a {
          color: #2b6e36;
          text-decoration: none;
          font-weight: 500;
        }
        
        .back-link a:hover {
          text-decoration: underline;
        }
        
        /* Popup overlay styles */
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        
        .popup-form {
          background: white;
          padding: 30px;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          max-width: 500px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
        }
        
        .popup-form h3 {
          margin-top: 0;
          color: #2b6e36;
          text-align: center;
        }
        
        .popup-form input {
          width: 100%;
          padding: 12px 14px;
          margin-bottom: 15px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 15px;
          transition: all 0.3s ease;
        }
        
        .popup-form input:focus {
          border-color: #2b6e36;
          outline: none;
          box-shadow: 0 0 0 3px rgba(43, 110, 54, 0.2);
        }
        
        .popup-form .voucher-btn {
          width: 100%;
          background: #2b6e36;
          color: #fff;
          font-size: 16px;
          padding: 14px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          transition: background 0.3s ease;
          margin-top: 10px;
        }
        
        .popup-form .voucher-btn:hover {
          background: #23822e;
        }
        
        .error-text {
          color: #dc3545;
          font-size: 14px;
          margin-top: -10px;
          margin-bottom: 10px;
        }
        
        @media (max-width: 768px) {
          .popup-form {
            padding: 20px;
          }
          
          .how-it-works ol, .benefits ul {
            padding-left: 20px;
            text-align: left;
            list-style-position: outside;
          }
        }
      `}</style>
    </div>
  );
}

export default LoyaltyBookletCard;